import { FC, useCallback, useEffect, useState } from 'react';
import { getMsFromMin } from '../../utils/time-helper';
import { IdleUserListenerProps } from './IdleUserListener.props';

/**
 * IdleUserListener listens to the events thats are fired during session and reset counter for session.
 */
const IdleUserListener: FC<IdleUserListenerProps> = ({
  timeoutMinutes,
  onTimeout,
  disabled,
}) => {
  const [resetAction, setResetAction] = useState(true);

  const timeoutMilliseconds = getMsFromMin(timeoutMinutes);

  useEffect(() => {
    let id: number;
    if (!disabled) {
      id = window.setTimeout(() => {
        onTimeout();
      }, timeoutMilliseconds);
    }
    return () => {
      if (id) {
        window.clearTimeout(id);
      }
    };
  }, [timeoutMilliseconds, resetAction, onTimeout, disabled]);

  const reset = useCallback(() => {
    setResetAction((p) => !p);
  }, []);

  useEffect(() => {
    if (!disabled) {
      window.addEventListener('click', reset, false);
      window.addEventListener('mousemove', reset, false);
      window.addEventListener('keypress', reset, false);
      window.addEventListener('scroll', reset, false);
      document.addEventListener('touchMove', reset, false);
      document.addEventListener('touchEnd', reset, false);
    }
    return () => {
      window.removeEventListener('click', reset);
      window.removeEventListener('mousemove', reset);
      window.removeEventListener('keypress', reset);
      window.removeEventListener('scroll', reset);
      document.removeEventListener('touchMove', reset);
      document.removeEventListener('touchEnd', reset);
    };
  }, [reset, disabled]);

  return null;
};

IdleUserListener.defaultProps = {
  timeoutMinutes: 60,
};

export default IdleUserListener;
